// extracted by mini-css-extract-plugin
module.exports = {"element":"Heading5_element__kKP0X"};